import { chatActions } from "../action/types";

const initialState = {
    countMessage: null
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case chatActions.CHAT_COUNT_READABLE: {
        const { count } = action.payload;
        const object = {
            ...state,
            countMessage: count.message
        }
        return object;
    }
    default:
      return state;
  }
}

export default chatReducer;
